export const MESSAGES = {
  imageIsRequired: "Images are required.",
  notMoreFiveImage: "You can upload 5 images.",
  categoryHasBeenSuccessfullyCreated: "Category Has Been Successfully Created",
  productHasBeenSuccessfullyCreated: "Product Has Been Successfully Created",
  certificateHasBeenSuccessfullyCreated: "Certificate Has Been Successfully Created",
  certificateHasBeenSuccessfullyUpdated: "Certificate Has Been Successfully Updated",
  somethingWentWrong: "Something Went Wrong",
  imageSize: 'Images must be JPEG, JPG, WebP or PNG format and under 5MB.',
  workHasBeenSuccessfullyCreated: "Work Has Been Successfully Created"
}
